import { ImgProps } from "./types";

export default function ImgJacque(props: ImgProps) {
	const { height = 643, width = 508 } = props;
	return (
		<img
			src="/assets/images/img-jacque.webp"
			alt="Jacque Menassa"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
